import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDHeadlineText } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { Layout } from './Layout';
import { SignedAtComponent } from './SignedAtComponent';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('signedAt', {
    _component: () => SignedAtComponent,
  }, overrideReadOnly)
  .done();


const EndorserAgreementPage = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

EndorserAgreementPage.defaultProps = {
};

EndorserAgreementPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { EndorserAgreementPage };
